import React, { useState, useEffect } from 'react';
import Accordian from '../../common/components/Accordian/Accordian.js'
import logo from "../../common/media/cc_logo_white.svg";
import { formatNumber } from "../../common/util/numberFormatter";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { projects as getProjects } from '../../common/api/projects'
import ProjectsList from "./../Projects/ProjectsList";
import Popover from "../../common/components/popover/popover.js";
import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration.js';


const LandingPage = ({ merchantCode, fetchedImpact }) => {
    const [projects, setProjects] = useState();
    
    const numberOfContributions = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.numberOfContributions?.value);
    const carbonOffsetImpact = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.carbonOffsetImpact?.value));
    const carbonOffsetImpactUnit = fetchedImpact && !fetchedImpact.error && fetchedImpact.carbonOffsetImpact?.unit.toLowerCase()
    const treeGrowthYears = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.treeGrowthYears?.value);
    
    const treeMetric = treeGrowthYears && <span className="translate-dynamic"><span>An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as </span> <span className="no-translate"> {treeGrowthYears}</span> <span>trees have in one year.</span></span>
        
    useEffect(() => {
        getProjects(null, merchantCode)
            .then(response => response.json())
            .then(data => setProjects(data))
            .catch(setProjects);

    }, []);

    return (
        <div>
            <div className="transparent-header">
                <div className="container">
                    <a target="_blank" href="https://www.earthshare.org/">
                        <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1628682181/Enterprise/earthshare/earthshare-logo_anpnx5.svg`} style={{height: '65px'}} />
                    </a>                    
                </div>
            </div>
            <div className="h-85vh w-100 position-relative img-cover hero-img vertical-align-parent bg-grey" >
               
                <div className="container color-white text-align-start vertical-align">
                    <div>
                        <div className="mw-720px">
                            <h1 className="text-shadow mt-0 text-primary">Share the Earth.<br />Share the Responsibility.</h1>
                            <p className="text-shadow bnr-text">We want to help you on your climate journey. Learn about your carbon footprint and how you can reduce your environmental impact. </p>
                            <a href="#PersonalCalculator" className="btn btn-primary">Calculate my footprint</a>
                        </div>

                        <div className="d-flex mobile-hide">
                            <p className="mr-2 mt-0">Powered by</p>
                            <div>
                                <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 26 }} src={logo} /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mobile-show">
                <div className="bg-primary p-3 text-center">
                    <div className="d-flex w-fit center color-white">
                        <p className="mr-2 font-bold mt-0 mb-0">Powered by</p>
                        <div>
                            <a className="d-flex" target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 26 }} src={logo} /></a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-90 join-circle-section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-md-6">
                            <h3 className="text-secondary text-right text-sm-center mt-0">Join EarthShare and CarbonClick in fighting the climate crisis!</h3>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <p className="text-grey text-left text-sm-center mt-1">EarthShare is committed to helping everyone, individuals and organizations, take climate action. While we must first reduce our carbon footprints, high-quality and verified carbon offsets present a tangible and valuable opportunity for any of us to help tackle our shared global challenge</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-90">
                <div className="container text-center">
                    <div className="mb-4 pb-3 center">
                        <h2 className="font-bold text-secondary mb-4 pb-2 mt-0">Together we are fighting <br/>climate change</h2>
                        <div className="row justify-content-center align-items-center">
                            <div className="col-md-auto">
                                <span className="overTag mr-3">Over</span>
                                <span className="bigTxt text-primary">500</span>
                            </div>
                            <div className="col-md-auto">
                                <h4 className="text-secondary mt-0 mb-0 d-inline-block text-left text-sm-center">Organizations and individuals<br/> taking climate action</h4>
                            </div>
                        </div>
                    </div>
                    {/* Commented in CAR-202*/}
                    {/* <div className="mobile-hide">
                        <div>
                            <div className="row text-align-start">

                                <div className="col-4 d-grid">
                                    <div className="center w-100">
                                        <div className="img-cover img-1 w-100">
                                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1628760183/Enterprise/earthshare/image_42_rznlwp.jpg`}/>
                                        </div>
                                        <div className="font-bold">
                                            <h2 className="count-title text-secondary mb-2">{numberOfContributions}</h2>
                                            <p className="text-grey mdm mt-0">Individuals taking climate action</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-4 d-grid">
                                    <div className="center w-100">
                                        <div className="img-cover img-1 w-100">
                                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1628760183/Enterprise/earthshare/image_55_cj7clk.jpg`} />
                                        </div>
                                        <div className="font-bold">
                                            <h2 className="count-title text-secondary mb-2">{carbonOffsetImpact}</h2>
                                            <p className="text-grey mdm mt-0">{carbonOffsetImpactUnit} of CO2 Offset</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-4 d-grid">
                                    <div className="center w-100">
                                        <div className="img-cover img-1 w-100">
                                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1628760183/Enterprise/earthshare/image_52_caq5i3.jpg`} />
                                        </div>
                                        <div className="font-bold">
                                            <h2 className="count-title text-secondary mb-2">{treeGrowthYears}</h2>
                                            <p className="text-grey mdm mt-0"><span className="mr-2">Tree Growth Years</span>
                                                <Popover content={treeMetric} >
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                                                        <path d="M0 0h24v24H0z" fill="none" />
                                                        <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                                                    </svg>
                                                </Popover>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
                
                <div className="mobile-show bg-primary py-3 mt-4 text-center">
                    <div className="container">
                        <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true}>
                            <div key="1">
                                <div className="center w-100">
                                    <div className="img-cover img-1 w-100">
                                        <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1628760183/Enterprise/earthshare/image_42_rznlwp.jpg`} />
                                    </div>
                                    <div className="font-bold">
                                        <h2 className="count-title text-secondary mb-2">{numberOfContributions}</h2>
                                        <p className="text-grey mdm mt-0">Individuals taking climate action</p>
                                    </div>
                                </div>
                            </div>

                            <div key="2">
                                <div className="center w-100">
                                    <div className="img-cover img-1 w-100">
                                        <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1628760183/Enterprise/earthshare/image_55_cj7clk.jpg`} />
                                    </div>
                                    <div className="font-bold">
                                        <h2 className="count-title text-secondary mb-2">{carbonOffsetImpact}</h2>
                                        <p className="text-grey mdm mt-0">{carbonOffsetImpactUnit} of CO2 Offset</p>
                                    </div>
                                </div>
                            </div>

                            <div key="3">
                                <div className="center w-100">
                                    <div className="img-cover img-1 w-100">
                                        <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1628760183/Enterprise/earthshare/image_52_caq5i3.jpg`} />
                                    </div>
                                    <div className="font-bold">
                                        <h2 className="count-title text-secondary mb-2">{treeGrowthYears}</h2>
                                        <p className="text-grey mdm mt-0"><span className="mr-2">Tree Growth Years</span>
                                            <Popover content={treeMetric} >
                                                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                                                    <path d="M0 0h24v24H0z" fill="none" />
                                                    <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                                                </svg>
                                            </Popover>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>

            <div className="pt-90">
                <div className="container text-center">
                    <div className="mb-4 pb-3 center">
                        <h2 className="font-bold text-secondary  mb-4 pb-2 mt-0">Why should we all care about<br/> Climate Change?</h2>
                        <p className="text-grey mdm mw-800px center">Climate change is happening so fast we can’t adapt fast enough. Human activities are responsible for the ongoing degradation of our planet.</p>
                        <p className="text-grey mdm mw-800px center mt-5">The 2021 Intergovernmental Panel on Climate Change (IPCC) report re-confirmed that climate change is widespread, rapid and intensifying. While some change is irreversible, every business and person needs to act now to reverse this trend.</p>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="icon-box h-100 py-4 px-4 green">
                                <img height="100" src={`https://res.cloudinary.com/carbonclick/image/upload/v1628762501/Enterprise/earthshare/Vector1_ypcn9z.svg`} />
                                <h4 className="text-secondary mb-4 pb-2">Prevent Global Warming</h4>
                                <p className="px-3 text-secondary">If climate change continues, our planet is at risk of increased extreme weather events, sea-level rise, food insecurity, water-shortages and large-scale biodiversity loss.</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="icon-box h-100 py-4 px-4 bg-primary text-secondary">
                                <img height="100" src={`https://res.cloudinary.com/carbonclick/image/upload/v1630906185/Enterprise/earthshare/reduced-inequalities_k5lrcu.svg`} />
                                <h4 className="text-secondary mb-4 pb-2">Reduced Inequalities</h4>
                                <p className="px-3 text-secondary">The Climate Crisis disproportionately affects people who suffer from socioeconomic inequalities, including many people of color.</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="icon-box h-100 py-4 px-4 pink text-secondary">
                                <img height="100" src={`https://res.cloudinary.com/carbonclick/image/upload/v1630906185/Enterprise/earthshare/environmental-protection_llwvax.svg`} />
                                <h4 className="text-secondary mb-4 pb-2">Environmental Protection</h4>
                                <p className="px-3 text-secondary">Climate change poses a serious risk to our beautiful natural environments, which can be restored by supporting nature based climate change solutions.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pt-90">
                <div className="container text-center">
                    <div className="mb-4 pb-3 center">
                        <h2 className="font-bold text-secondary  mb-4 pb-2 mt-0">Begin your climate action journey by better understanding your carbon footprint.</h2>
                        <p className="text-grey mdm mw-800px center">Before we can look to reduce and ultimately offset our carbon footprint we must understand the main sources of our emissions. </p>
                    </div>
                </div>
                <iframe id="PersonalCalculator" className="calculator-iframe  d-flex flex-wrap" src={process.env.MY_CC_URL + '/personal-calculator-embed?merchantCode=BES_US_EARTHSHARE&hideSave=true&hideCookieNotice=true'}></iframe>
                <div className="text-center mt-5">
                    <a href="https://www.earthshare.org/individuals" className="btn btn-primary mt-3" target="_blank">Learn More</a>
                </div>
            </div>

            {Array.isArray(projects) && (
            <div className="py-90 dark-green">
                <div className="container text-center">
                    <div className="mb-4 pb-3 center">
                        <h2 className="font-bold text-white  mb-4 pb-2">Support Projects That Fight Climate Change</h2>
                        <p className="text-white mdm center">Together we will fund carbon offset projects that have been certified by the most reputable registries, such as the Gold Standard, Verra Carbon Standard and the American Carbon Registry. These standards provide a methodology framework, independent verification process, and a registry to ensure emissions reductions are real, additional, permanent and unique. </p>
                        <p className="text-white mdm center mt-4 pt-2">We seek projects that contain co-benefits wherever possible, so in addition to carbon sequestration we consider benefits to local communities, biodiversity and more.</p>
                    </div>
                    <ProjectsList title={null} projects={projects} />
                    <p className="text-white mdm center mt-5">To enable our unique track and trace feature, carbon credits are pre-purchased, which means  you can immediately see the retirement certificates from the projects you are supporting and know your contribution creates a direct impact.</p>
                    <p className="text-white mdm center mt-4 mb-0 pt-2">A key feature of our carbon offsets is “additionality,” meaning that the project could not go ahead without the finance of carbon credits. We rigorously analyze our projects to ensure that additionality criteria is met.</p>
                </div>
            </div>
            )}

            <div className="py-90">
                <div className="container text-center">
                    <div className="mb-4 pb-3 center">
                        <h2 className="font-bold text-secondary  mb-4 pb-2 mt-0">Partner with EarthShare</h2>
                        <p className="text-grey mdm mw-800px center">EarthShare and its network of Nonprofit Partners, individuals, workplaces, and communities exist to ensure a shift to a more just and sustainable future. Please join us!</p>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="icon-box h-100 py-4 px-4 bg-primary">
                                <img height="100" src={`https://res.cloudinary.com/carbonclick/image/upload/v1630907183/Enterprise/earthshare/workplace_jilsld.svg`} />
                                <h4 className="text-secondary mb-4 pb-2">Workplace Giving & Engagement</h4>
                                <p className="px-3 text-secondary">EarthShare provides world class technology and deep environmental expertise to help workplaces engage employees through giving, volunteering, carbon offsetting, and other action. </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="icon-box h-100 py-4 px-4 yellow">
                                <img height="100" src={`https://res.cloudinary.com/carbonclick/image/upload/v1630907183/Enterprise/earthshare/corporate_b1uzij.svg`} />
                                <h4 className="text-secondary mb-4 pb-2">Corporate Partnerships</h4>
                                <p className="px-3 text-secondary">EarthShare collaborates with businesses on one-time and ongoing projects to engage employees and consumers and move the needle on sustainability goals.</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="icon-box h-100 py-4 px-4 red">
                                <img height="100" src={`https://res.cloudinary.com/carbonclick/image/upload/v1630907183/Enterprise/earthshare/individual_c348jd.svg`} />
                                <h4 className="text-secondary mb-4 pb-2">Individual Action</h4>
                                <p className="px-3 text-secondary">EarthShare works with individuals outside of the workplace to provide educational resources and a one-stop-platform for giving, volunteering, offsetting, and more.</p>
                            </div>
                        </div>
                    </div>
                    <div className="text-center mt-5">
                        <h4 className="bt-title text-center text-secondary mb-4">Start your climate action journey today</h4>
                        <a href="https://www.earthshare.org/individuals" className="btn btn-primary mt-3" target="_blank">Learn More</a>
                    </div>
                </div>
            </div>

            <div className="py-90">
                <div className="container text-center">
                    <h2 className="font-bold text-secondary mt-0">FAQs</h2>
                    <div className="mb-3 center text-align-start mw-800px">
                        <Accordian title={"What are Carbon Credits?"} >A carbon credit is mechanism used to measure and support projects that fight climate change. For every tonne of CO2 that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are certified by international standards and held in registries like the Gold Standard registry (international credits) and can be purchased to reduce the carbon impact of an initiative or activity.</Accordian>
                        <Accordian title={"What makes a \"high quality\" carbon offset?"} >CarbonClick follows industry best practice to ensure that the offsets provided have a real, measurable impact on mitigating climate change. Projects are scrutinised against their independently verified selection methodology, which uses many of the same stringent requirements of ICROA Code of Best Practice, such as true additionality, ensuring credible baseline reporting and verifying project developers integrity. Only projects that have considerable co-benefits are considered, such as improving biodiversity, creating sustainable jobs, empowering women and minorities and improving community health and wellbeing. </Accordian>
                        <Accordian title={"Where does the money go?"} >To enable their unique track and trace feature, CarbonClick pre-purchases carbon credits. This transparent reimbursement model means that you can immediately see the retirement certificates from the projects you are supporting and know your contribution is having a direct impact. A key feature of a carbon offsetting project is additionality, which means the project could not go ahead without the finance of carbon credits. We rigorously analyse our projects to ensure that additionality criteria is being met and your money is having a direct impact.</Accordian>
                        <Accordian title={"How do I get details of my carbon offset purchase?"} >Every carbon offset appears in the transaction history section in EarthShare, and your personal offsetting dashboard, which you can sign in to at <a href="https://my.carbon.click" target="_blank">https://my.carbon.click</a> (using the same email as you use in EarthShare).  Additionally, immediately following a purchase you will get a receipt, showing you your impact and allowing you to track and trace where it's having an impact.</Accordian>
                        <Accordian title={"Who are CarbonClick?"} >CarbonClick is a New Zealand company that exists to reverse climate change by empowering businesses and their customers to take climate action. By making carbon offsets simple, trustworthy and cost effective, CarbonClick is connecting millions of people to high quality offsetting projects that restore nature and reduce pollution, building a happier and more sustainable future for everyone.</Accordian>
                    </div>
                </div>
            </div>

            <div className="w-100 img-cover footer-img py-6 bg-grey" >
                <div className="container color-white py-5">
                    <p><b>Powered by</b></p>
                    <div className="d-flex">
                        <div>
                            <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                                <img style={{ height: 30 }} className="footer-logo" src={logo} alt="carbonclick" />
                            </a>
                        </div>
                    </div>
                    <hr className="mb-4" />

                    <div className="row justify-content-between">
                        <div className="col-md-auto">
                            <div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                            </div>
                        </div>
                        <div className="col-md-auto">
                            <div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                            </div>
                        </div>
                        <div className="col-md-auto">
                            <div>
                                <div className="mb-3"><a className="color-white" href="mailto:support@carbonclick.com" target="_blank" rel="noopener noreferrer">support@carbonclick.com</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default LandingPage;